module.exports = __webpack_public_path__ + "img/the-other-boleyn-girl.985bd3a8.png";